module.exports = __webpack_public_path__ + "img/katarina_bedrooms_6.eea46d2b.jpg";